const wsHost = window?.ENV?.WS_HOST || "";
import WSServer from "@/services/ws";
const realtimePrivate = new WSServer(`${wsHost}/api/v1/private/ws`, true);
export default realtimePrivate;
